const icon = require('vue-svgicon');
icon.register({
    'menu': {
        width: 32,
        height: 32,
        viewBox: '0 0 32 32',
        data: `<path pid="0" d="M22.71 27.091H1.523a1.524 1.524 0 010-3.048H22.71a1.524 1.524 0 010 3.048zM30.477 17.525H1.523a1.524 1.524 0 010-3.048h28.954a1.524 1.524 0 010 3.048zM26.163 7.958H1.523a1.524 1.524 0 010-3.049h24.64a1.524 1.524 0 010 3.049z"/>`,
    },
});
